import { render, staticRenderFns } from "./edit-big.vue?vue&type=template&id=0a32dc04&scoped=true&"
import script from "./edit-big.vue?vue&type=script&lang=js&"
export * from "./edit-big.vue?vue&type=script&lang=js&"
import style0 from "./edit-big.vue?vue&type=style&index=0&id=0a32dc04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32dc04",
  null
  
)

export default component.exports